import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Don't render on admin pages (sidebar handles navigation)
  if (location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/admin")) {
    return null;
  }

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  const navClassName = ({ isActive }) => (isActive ? "active" : "");

  return (
    <nav className="top-navbar">
      <div className="navbar-inner">
        <NavLink to="/" className="navbar-brand" onClick={closeMenu}>
          <img src="/assets/img/nab_photo.jpeg" alt="Nadia A." className="navbar-avatar" />
          <span className="navbar-name">Nadia A.</span>
        </NavLink>

        <ul className="navbar-links">
          <li>
            <NavLink to="/" end className={navClassName}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/blog" className={navClassName}>
              Blog
            </NavLink>
          </li>
          <li>
            <NavLink to="/cheat-sheet" className={navClassName}>
              Cheat sheet
            </NavLink>
          </li>
        </ul>

        <div className="navbar-social">
          <a
            href="https://www.linkedin.com/in/nadia-abdallah-581a2048/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a
            href="https://github.com/NadNadou"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://www.youtube.com/@datamory1208"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-youtube"></i>
          </a>
        </div>

        <div className={`menu-toggle ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {menuOpen && (
        <div className="navbar-mobile-menu">
          <NavLink to="/" end className={navClassName} onClick={closeMenu}>Home</NavLink>
          <NavLink to="/blog" className={navClassName} onClick={closeMenu}>Blog</NavLink>
          <NavLink to="/cheat-sheet" className={navClassName} onClick={closeMenu}>Memo</NavLink>
          <div className="navbar-mobile-social">
            <a href="hwww.linkedin.com/in/nadia-a-581a2048" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://github.com/NadNadou" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github"></i>
            </a>
            <a href="https://www.youtube.com/@datamory1208" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

Header.propTypes = {};

export default Header;
